<template>
    <va-create-layout>
        <RefundEventShipmentItemCharge-form
            :title="title"
            :item="item"
        ></RefundEventShipmentItemCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
